import { render, staticRenderFns } from "./VimeoEmbed.vue?vue&type=template&id=31a294a7"
import script from "./VimeoEmbed.vue?vue&type=script&lang=js"
export * from "./VimeoEmbed.vue?vue&type=script&lang=js"
import style0 from "./VimeoEmbed.vue?vue&type=style&index=0&id=31a294a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports